export default {
  zIndex: new class ZIndex {
    locateuser = Number.MAX_SAFE_INTEGER -1 
    measureTool = Number.MAX_SAFE_INTEGER - 2;
    COMMENTS = Number.MAX_SAFE_INTEGER - 3;
    mask = Number.MAX_SAFE_INTEGER - 4;
    gaugeLayer= Number.MAX_SAFE_INTEGER - 5;
    crossSectionLayer= Number.MAX_SAFE_INTEGER - 6;
    COMMENTS_GEOM= Number.MAX_SAFE_INTEGER - 7;
    additionalLayersAboveWater= Number.MAX_SAFE_INTEGER - 8;
    particleLayer= 99;
    hillshade= 3;
    vectorfield= 20;
    outline= 13;
    outlinemask= 12;
    vecFieldRenderer= 5;
    additionalLayersBelowWater= 4.5;
    waterlevel= 4;
  },
  paths: new class Paths {
    h_PATH = "h/{ts}/{z}/{y}/{x}.png";
    h_rendered_PATH = "h_rendered/{ts}/{z}/{y}/{x}.png";
    veloc_PATH = "veloc/{ts}/{z}/{y}/{x}.png";
    mesh_height_cm_PATH = "mesh_height_cm/{z}/{y}/{x}.png";
    hillshade_PATH = "hillshade/{z}/{y}/{x}.png";
  }
  
}